import HttpClient from './HttpClient'

class TenantsApiClient extends HttpClient {

    constructor(baseURL, module, token) {
      super({
        baseURL,
        module,
        token
      });

      this.module = module;
    }
  
    get userProfile() {
      return {
        get: () => this.get(`user-tenants?module=${this.module}`)
      };
    }
  
  }
  
  export default TenantsApiClient